import {useDroppable} from '@dnd-kit/core';
import { CSS } from "@dnd-kit/utilities";
import { Card} from "react-bootstrap";



export function AdminDashboardDroppableItem(props) {
    //props.id
    // id will be time
    const {
        attributes,
        listeners,
        // node ref should be showing up as funcn
        setNodeRef,
        transform,
        transition
    } = useDroppable({id: props.id});
    
    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    }
    
    return(
        <td ref={setNodeRef} style={style} {...attributes} {...listeners}>
            
        </td>
    )
}



